import { atom } from "recoil";
import { InstObject } from "../config/types";
const default_Insts: InstObject[] = [];

export const selectedRedbookInstsR = atom({
    key: "selectedRedbookInstsR",
    default: default_Insts,
});
export const selectedRedbookInstsKeptR = atom({
    key: "selectedRedbookInstsKeptR",
    default: default_Insts,
});
